import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.734 2.299a.75.75 0 0 1 .827.203l8 9a.75.75 0 0 1 0 .996l-8 9A.75.75 0 0 1 12.25 21v-5.194q-.202.023-.448.06c-.768.118-1.837.356-3.023.83-1.083.434-2.36 1.571-3.421 2.694a28 28 0 0 0-1.728 2.02l-.023.031-.006.007-.001.002A.75.75 0 0 1 2.25 21H3h-.75v-.07l.005-.177c.006-.153.016-.372.036-.645.04-.544.122-1.306.284-2.182.322-1.738.974-3.985 2.315-5.862 1.361-1.906 3.375-3.1 4.995-3.813a17 17 0 0 1 2.365-.84V3a.75.75 0 0 1 .483-.701m.413 6.437-.008.001-.035.008-.148.034c-.13.032-.324.081-.566.152a16 16 0 0 0-1.9.693c-1.505.662-3.241 1.718-4.38 3.312-1.16 1.623-1.757 3.626-2.06 5.263q-.045.25-.083.484.146-.16.3-.323c1.065-1.127 2.537-2.49 3.954-3.056a15.4 15.4 0 0 1 3.352-.92 12 12 0 0 1 1.312-.132l.08-.002h.034L13 15v-.75a.75.75 0 0 1 .75.75v4.027L19.997 12 13.75 4.973V8a.75.75 0 0 1-.603.736",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }